import {
  Grid,
  Paper,
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { ChangesData, formatProperty } from 'components/ChangeDataTable/ChangeDataTable';
import { DialogButton } from 'components/DialogButton/DialogButton';
import { LogsDialog } from 'components/Dialogs';
import strings, { url } from 'constants/index';
import { UTCSingleDate } from 'utils/formatter.utils';

import { useLogTableStyles } from './LogTable.styles';
import { JsonDiffCell } from './JsonDiffCell';

export interface Log extends ChangesData {
  logDate: string;
  source: string;
  triggerType: string;
  isOdd: boolean;
}

interface Props {
  data: Log[];
}

export const LogsTable = ({ data }: Props) => {
  const styles = useLogTableStyles();
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item xs>
        <TableContainer component={Paper} className={styles.tableContainer}>
          <MUITable stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="left">{strings.log_date}</TableCell>
                <TableCell align="left">{strings.log_by}</TableCell>
                <TableCell align="left">{strings.action}</TableCell>
                <TableCell align="left">{strings.property_name}</TableCell>
                <TableCell align="left">{strings.old_value}</TableCell>
                <TableCell align="left">{strings.current_value}</TableCell>
                <TableCell align="left">{strings.source}</TableCell>
                <TableCell align="left">{strings.trigger_type}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((log, idx) => {
                const formattedChange = formatProperty(log);
                return (
                  <TableRow key={idx} className={log.isOdd ? styles.tableRow : ''}>
                    <TableCell variant="body" align="left">
                      {UTCSingleDate(log.logDate, true)}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      {formattedChange.logBy}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      {formattedChange.action}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      {formattedChange.propertyName}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      <JsonDiffCell
                        oldValue={formattedChange.oldValue}
                        currentValue={formattedChange.currentValue}
                        isOldValue={true}
                      />
                    </TableCell>
                    <TableCell>
                      {formattedChange.propertyName === 'DeletedOldFixtureId' ? (
                        <DialogButton
                          data-testid="logs"
                          label={formattedChange.currentValue}
                          dialog={LogsDialog}
                          variant="text"
                          disableRipple
                          dialogProps={{
                            entityName: `${formattedChange.propertyName} - ${formattedChange.currentValue}`,
                            logsUrl: `${url.fixtures}/${formattedChange.currentValue}${url.logs}`,
                          }}
                          className={styles.deletedEntityCell}
                        />
                      ) : (
                        <JsonDiffCell
                          oldValue={formattedChange.oldValue}
                          currentValue={formattedChange.currentValue}
                          isOldValue={false}
                        />
                      )}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      {log.source}
                    </TableCell>
                    <TableCell variant="body" align="left">
                      {log.triggerType}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </MUITable>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
